import { Link } from "react-router-dom";
import LogoMissing from "../assets/images/LogoMissing.png";
import LoginWoxa from "../assets/images/Logowoxalogin.png";
import { useSelector } from "react-redux";
import { State } from "../reducer";

const NotFound = () => {
  const user = useSelector((state: State) => state.user);
  return (
    <>
      <div className="flex flex-col font-nunito justify-center h-screen items-center bg-white">
        <img src={LogoMissing} alt="waiting..." className="w-auto h-[168px]" />
        <div className="text-xl font-medium text-center text-primary-onligth">
          Sorry, something <br />
          went wrong :(
        </div>

        <div className="flex flex-col mt-16">
          <Link
            to={
              user.role === "admin"
                ? "/statusOrder-admin"
                : user.role === "user"
                ? "/statusOrder"
                : "/ordering"
            }
          >
            <span className="btn-new primary ">Back to home</span>
          </Link>
        </div>
      </div>
      <footer className="fixed mb-20 bottom-0 left-0 right-0 flex justify-center">
        <img src={LoginWoxa} alt="Logo" className="w-[134px] h-auto" />
      </footer>
    </>
  );
};

export default NotFound;
